"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedItemWithSpecificTypeOrCustomNameSchema = void 0;
const zod_1 = require("zod");
const selectedItem_schema_1 = require("./selectedItem.schema");
const selectedCustomItem_schema_1 = require("./selectedCustomItem.schema");
const selectedItemWithSpecificTypeOrCustomNameSchema = (type, omit) => zod_1.z.union([(0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(type, omit), selectedCustomItem_schema_1.selectedCustomItemSchema]).transform((data) => {
    if ("customName" in data) {
        return { customName: data.customName };
    }
    return { id: data.id };
});
exports.selectedItemWithSpecificTypeOrCustomNameSchema = selectedItemWithSpecificTypeOrCustomNameSchema;
//# sourceMappingURL=selectedItemWithSpecificTypeOrCustomName.schema.js.map